/** @format */

import React, { useEffect } from 'react';
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import Container from 'react-bootstrap/Container';
import BrokerProfileContent from 'views/Broker/Profile/BrokerProfile/BrokerProfileContent';
import getUrlParams from 'utils/getUrlParams';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchBrokerObjects,
  fetchBrokerObjectsBySlug,
  fetchBrokerProfile,
  fetchBrokerProfileBySlug
} from 'stateContainer/actions';
import { Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

export default function BrokerProfile(props) {
  const dispatch = useDispatch();
  const {
    brokerProfile: {
      data: { user },
      isFetching,
      isFetchingMore
    },
    brokerObjects: { data, isFetching: isObjectsFetching, page, totalPages },
    session: {
      data: { userData = null }
    }
  } = useSelector((state) => state);
  const { tprop } = props;

  const { profileId } = getUrlParams(['profileId']);

  const { profileSlug } = useParams();

  const target = React.useRef(null);
  const [show, setShow] = React.useState(false);
  const [copyProfileUrlSuccess, setCopyProfileUrlSuccess] = React.useState('');

  const copyToClipBoard = async (copiedText) => {
    await navigator.clipboard.writeText(copiedText);
    setCopyProfileUrlSuccess(tprop.header.copyLink.text);
  };

  const onClickCopyProfile = () => {
    copyToClipBoard(window.location.href);
    setShow(!show);
    setTimeout(() => {
      setShow(false);
    }, 1500);
  };

  useEffect(() => {
    if (profileId) {
      dispatch(
        fetchBrokerProfile({ brokerId: profileId, vitecId: userData.vitecId })
      );

      dispatch(fetchBrokerObjects(profileId));
    } else if (profileSlug) {
      dispatch(
        fetchBrokerProfileBySlug({
          brokerSlug: profileSlug,
          vitecId: userData.vitecId
        })
      );
      dispatch(fetchBrokerObjectsBySlug(profileSlug));
    }
  }, []);

  const ProfileContent = () => {
    return (
      <Container fluid className='content-wrapper'>
        {user !== undefined && (
          <>
            <BrokerProfileContent
              {...props}
              properties={data}
              muncipality={user.muncipality}
              brokerEmail={user.fmEmail}
              brokerPhone={user.phonenumber}
              copyToClipBoard={copyToClipBoard}
              copyProfileUrlSuccess={copyProfileUrlSuccess}
              onClickCopyProfile={onClickCopyProfile}
              target={target}
              show={show}
              status={user.status}
              activeObjectCount={user.activeObjectCount}
              completedSalesCount={user.completedSalesCount}
              showCopySuccess={show}
              firstName={user.firstName}
              lastName={user.lastName}
              profilePic={user.image}
              description={user.description}
              services={user.services}
              usps={user.usp}
              totalPages={totalPages}
              page={page}
              profileId={profileId}
              profileSlug={profileSlug}
              isFetchingMore={isFetchingMore}
              region={user?.region}
            />
          </>
        )}
      </Container>
    );
  };

  const isLoading = isFetching || isObjectsFetching;
  return (
    <>
      <div className='main-container broker-profile-view'>
        <Header flow={props.flow} {...props} />

        {isLoading && (
          <Container fluid className='broker-profile-loading-container'>
            <Spinner
              animation='border'
              role='status'
              style={{ color: 'var(--color-primary-pink)' }}
            />
          </Container>
        )}

        {!isLoading && <ProfileContent />}

        <Footer {...props} />
      </div>

      <div className='main-container broker-profile-view-mobile'>
        <Header flow={props.flow} {...props} />

        {!isLoading && <ProfileContent />}

        <Footer {...props} />
      </div>
    </>
  );
}
